export const iconFontAwesomeSciencefictionHandSpock = (
	<i className="fa-solid fa-hand-spock"></i>
);
